import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class GameBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { gameTopic, gameTitle, gameList0, gameList1, gameList2 },
        } = this.props;

        return (
            <div id="gameNewsList" className={styles.game_box}>
                <Chip id="50070" type="struct" title="游戏栏标题" groupName="游戏栏" content={gameTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75073"
                    type="recommend"
                    title="游戏栏头条"
                    groupName="游戏栏"
                    content={gameTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75074"
                    type="recommend"
                    title="游戏栏新闻列表1"
                    groupName="游戏栏"
                    content={gameList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList hasEnd />
                </Chip>
                <Chip
                    id="75075"
                    type="recommend"
                    title="游戏栏新闻列表2"
                    groupName="游戏栏"
                    content={gameList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
                <Chip
                    id="75076"
                    type="recommend"
                    title="游戏栏新闻列表3"
                    groupName="游戏栏"
                    content={gameList2}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(GameBox);
